import { AnyAction } from '@reduxjs/toolkit';

/**
 * Check if an error is a condition abort from RTK Query (intentional query skip)
 * These are not real API failures and should not trigger error handling
 */
export const isConditionError = (action: AnyAction): boolean => {
  return (
    action.error?.name === 'ConditionError' ||
    action.error?.message?.includes('Aborted due to condition')
  );
};
